import React from "react";
import RadioGroup from "@techsoftware/happay-widgets/RadioGroup";

export default class customRadioGroup extends React.Component {
    render() {
        return (
            <RadioGroup
                {...this.props}
                // value={state.disabledDemo}
                // label="Disabed and Enabled Radio button demo"
                // onClick={value => onClick('disabledDemo', value)}
                // labelPlacement="top"
                // direction={this.props.direction}
                // radioButton={[
                //     { id: 'disabledDemo1', value: 'disabledDemo1', disabled: true },
                //     { id: 'disabledDemo2', value: 'disabledDemo2' },
                //     { id: 'disabledDemo3', value: 'disabledDemo3' },
                //     { id: 'disabledDemo4', value: 'disabledDemo4' },
                // ]}
            />
        );
    }
}
